import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import Form from "../../../Reusable/Form/Form.js";
import useReduxUser from "hooks/useReduxUser.ts";
import config from "config";
import ToastHtmlComponent from "../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import MfaSecurity from "./MfaSecurity/index.tsx";

import { useEffect } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import {
  NotificationFields,
  NotificationSubUserFields,
} from "./NotificationFields.js";
import { useToasts } from "react-toast-notifications";
import { selectSettings } from "store/selectors/userSelectors.ts";
import { useAppSelector } from "store/hooks.ts";

import "./Profile.scss";

const Notifications = () => {
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const { fetchUserSettings } = useReduxUser();
  const showSubUserSettings =
    getUserData()?.isTopUser &&
    (!!getUserData().subUsersCount ||
      getUserData().UserTotalSubUsersLicenses > 0);

  useEffect(() => {
    fetchUserSettings();
  }, []);

  const settings = useAppSelector(selectSettings);

  if (!settings) return null;

  //check the value of Email notifications alert type by 2 variables
  //this function return the radio input value to show
  const checkEmailNotificationsType = () => {
    let alert1 = true;
    let alert2 = true;
    if (
      settings.UserReceiveAlertMails !== null ||
      settings.UserReceiveAlertNotDownloadedMails !== null
    ) {
      alert1 = settings.UserReceiveAlertMails;
      alert2 = settings.UserReceiveAlertNotDownloadedMails;
    }
    if (alert2 && alert1) {
      return "AllMails";
    } else if (!alert2 && alert1) {
      return "AllMails";
    } else if (!alert2 && !alert1) {
      return "NoMails";
    } else if (alert2 && !alert1) {
      return "NotDownloadedMails";
    }
  };

  //save settings in API
  const handleFormSubmit = async (body) => {
    // User must select at least one auth option
    if (
      showSubUserSettings &&
      !body.GoogleSSO &&
      !body.Email &&
      !body.MicrosoftSSO
    ) {
      addToast(getTextByKey("no-sign-up-selected-option"), {
        appearance: "error",
      });
      return;
    }

    // remove the auto removal properties
    if (!getUserData().IsSubscribed) {
      delete body.AutoRemoveSettings;
    }

    const newBody = {
      ...body,
      IsReactPage: true,
      UserReceiveAlertMails: settings.UserReceiveAlertBeforeDeletionAllMails,
      UserReceiveAlertNotDownloadedMails:
        settings.UserReceiveAlertBeforeDeletionAllMails,
      UserReceiveDownloadLink: settings.UserReceiveDownloadLink,
      UserReceiveAlertInvalidRecipients:
        settings.UserReceiveAlertInvalidRecipients,
      UserReceiveEmbedDownloadOrStatusChange:
        settings.UserReceiveEmbedDownloadOrStatusChange,
      AuthenticationOptions: {
        Email: body.Email,
        GoogleSSO: body.GoogleSSO,
        MicrosoftSSO: body.MicrosoftSSO,
      },
      RecivceInvoices: body.ReceiveInvoices,
      InvoicesEmail: body.ReceiveInvoices ? body.InvoicesEmail : "",
      captchaServiceName: "cloudflare",
    };
    newBody.ToBlock = !body.ToBlock;

    const response = await apiRequest(
      "Users",
      "UpdateUserSettings",
      newBody,
      "POST"
    );
    if (response.status === "success") {
      //getUserSettings();
      addToast(getTextByKey("profilesettings-success"), {
        appearance: "success",
      });
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 999);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
    return response;
  };

  const fields = {
    ...NotificationFields,
    ...(showSubUserSettings ? NotificationSubUserFields : {}),
  };

  return (
    <div className="page-container-notifications">
      <div className="main-section-notifications">
        <h1>{getTextByKey("profilesettings-functional-title")}</h1>
        {!!settings ? (
          <Form
            submitProps={{
              title: getTextByKey("profilesettings-update"),
            }}
            fieldsProps={{ label: "hidden" }}
            fields={fields}
            defaultSelectObj={{
              EmailNotifications: { value: checkEmailNotificationsType() },
            }}
            externalProps={{
              settings,
            }}
            defaultValuesObj={{
              EnforceStrongPass: settings.EnforceStrongPass,
              UserReceiveDownloadNotification:
                settings.UserReceiveDownloadNotification,
              ToBlock: settings.ToBlock,
              // UserReceiveAlertBeforeDeletionAllMails:
              //   settings.UserReceiveAlertBeforeDeletionAllMails,
              // UserReceiveAlertInvalidRecipients:
              //   settings.UserReceiveAlertInvalidRecipients,
              UserReceiveRecipientAlertDelete:
                settings.UserReceiveRecipientAlertDelete,
              // UserReceiveEmbedDownloadOrStatusChange:
              //   settings.UserReceiveEmbedDownloadOrStatusChange,
              // UserReceiveMarketing: settings.UserReceiveMarketing,
              // UserReceiveDownloadLink: settings.UserReceiveDownloadLink,
              UserReceiveAlertBeforeDeletion:
                settings.UserReceiveAlertBeforeDeletion,
              UserReceiveMailCopy: settings.UserReceiveMailCopy,
              UserReceiveMarketing: settings.UserReceiveMarketing,
              UserPlaySounds: settings.UserPlaySounds,
              AutoRemoveSettings: {
                DefaultSaveMail: settings.AutoRemoveSettings?.DefaultSaveMail,
                AutoRemoveDays: settings.AutoRemoveSettings?.AutoRemoveDays,
              },
              SubUserSetBranding: settings.SubUserSetBranding,
              HideJumboPay: settings.HideJumboPay,
              HideJumboPicker: settings.HideJumboPicker,
              IsSubUserRestrictedToUsePrivateAccount:
                settings.IsSubUserRestrictedToUsePrivateAccount,
              Email: settings?.Email,
              GoogleSSO: settings?.GoogleSSO,
              MicrosoftSSO: settings?.MicrosoftSSO,
              ReceiveInvoices: settings.RecivceInvoices,
              InvoicesEmail: settings?.InvoicesEmail || getUserData()?.UserName,
            }}
            onSubmit={handleFormSubmit}
            captchaProvider="cloudflare"
          />
        ) : null}
        <MfaSecurity />
      </div>
    </div>
  );
};

export default Notifications;
